const { get } = require('lodash');

const mixin = {
  methods: {
    /*
     * This new helper method can be used to simplify translation calls.
     * Instead of calling multiple times in Vue component for translations as:
     * this.$t('averylongnameformysection.subsection.title'), it can be simplified as this.$tkey('subsection.title')
     * as long as localizationKey is passed as an option to the Vue component.
     *
     * The last parameter passed in can be an option object that contains a fallback, in case the translations are not loaded in context.
     * $tkey(`displayBy.${displayByMenu}`, { fallback: getDisplayByMenuFallbackName })
     * */
    $tkey(key, ...args) {
      let translation;
      if (!get(this, '$options.localizationKey')) {
        translation = this.$t(key, ...args);
      } else {
        translation = this.$t(`${this.$options.localizationKey}.${key}`, ...args);
      }

      // If translation fails check if last argument is an option object with a fallback
      if (translation === key || translation === `${this.$options.localizationKey}.${key}`) {
        return get(args.pop(), 'fallback', translation);
      }

      return translation;
    },
  },
};

export default mixin;
